module.exports = __webpack_public_path__ + "img/life-ring.be9a8bbd.svg";